import { default as Quill } from 'quill';
// import { AttachmentHandler, ImageHandler, VideoHandler } from "quill-upload";

import { AttachmentToolbarQuillModule } from './attachmentToolbar.quillModule';
import { CameraCaptureQuillModule } from './cameraCapture.quillModule';
import { ImageUploadQuillModule } from './imageUpload.quillModule';
import { TemplateToolbarQuillModule } from './templateToolbar.quillModule';
import { TimeBlot } from './time.blot';
import { VariableBlot } from './variable.blot';
import { VariableToolbarQuillModule } from './variableToolbar.quillModule';

// REGISTER QUILL MODULES HERE

export function registerQuillModules() {

	// register quill-upload
	// Quill.register("modules/imageHandler", ImageHandler);
	// Quill.register("modules/videoHandler", VideoHandler);
	// Quill.register("modules/attachmentHandler", AttachmentHandler);

	Quill.register(TimeBlot);

	Quill.register('modules/attachmentToolbar', AttachmentToolbarQuillModule);
	Quill.register('modules/cameraCapture', CameraCaptureQuillModule);
	Quill.register('modules/imageUpload', ImageUploadQuillModule);
	Quill.register('modules/templateToolbar', TemplateToolbarQuillModule);
	Quill.register('modules/variableToolbar', VariableToolbarQuillModule);
	Quill.register(VariableBlot);
	
}

export function getQuillFromHtmlElement(node: HTMLElement) {
	let parent = node.parentElement;
	while (parent && !parent.classList.contains('ql-container')) {
	  parent = parent.parentElement;
	}
	if (!parent) { return undefined; }
	return Quill.find(parent) as Quill;
}
